import React, { useCallback, useMemo, useReducer } from 'react';

import favoritesConstants    from './favorites.constants';
import favoritesInitialState from './favorites.state';
import FavoritesContext      from './favorites.context';
import favoritesReducer      from './favorites.reducer';

/**
 * @type {React.FC}
 */

const FavoritesProvider = function({
  children,
  value = favoritesInitialState,
}) {

  const [state, dispatch] = useReducer(favoritesReducer, value);

  const getFavorites = useCallback(() => {
    dispatch({
      type:    favoritesConstants.GET_VALUE,
      payload: value,
    });
    return state;
  }, [dispatch]);

  const context = useMemo(
    () => ({
      ...state,
      getFavorites,
    }),
    [getFavorites, state],
  );

  return (
    <FavoritesContext.Provider value={context}>
      {children}
    </FavoritesContext.Provider>
  );
};

export default FavoritesProvider;
